'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

exports.searchReducer = searchReducer;
exports.shareClassReducer = shareClassReducer;
exports.familyShareClassReducer = familyShareClassReducer;
exports.familyShareClasses = familyShareClasses;
exports.shareClassDetails = shareClassDetails;
exports.searchFunds = searchFunds;
exports.tutorialdismissReducer = tutorialdismissReducer;
exports.tutorialdismissChange = tutorialdismissChange;
exports.companyReducer = companyReducer;
exports.companies = companies;
exports.compareReducer = compareReducer;
exports.compareShareclasses = compareShareclasses;
exports.cartReducer = cartReducer;
exports.cartChange = cartChange;
exports.fundsByStrategyReducer = fundsByStrategyReducer;
exports.getFundsByStrategy = getFundsByStrategy;

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SEARCH = 'search';
var SEARCH_FAIL = 'search/fail';
var SEARCH_SUCCESS = 'search/success';

var SHARE_CLASS = 'share_class';
var SHARE_CLASS_FAIL = 'share_class/fail';
var SHARE_CLASS_SUCCESS = 'share_class/success';

var FAMILY_SHARE_CLASS = 'family_share_class';
var FAMILY_SHARE_CLASS_FAIL = 'family_share_class/fail';
var FAMILY_SHARE_CLASS_SUCCESS = 'family_share_class/success';

var initialState = {
  // searched: false
};

function whereParams(prefix, whereBy) {
  if (!whereBy) {
    return {};
  }
  var params = {};
  whereBy.forEach(function (where) {
    if (where) {
      if (where.op === 'eq') {
        params[prefix + '[' + where.name + ']'] = where.value;
      } else {
        params[prefix + '[' + where.name + '][' + where.op + ']'] = where.value;
      }
    }
  });
  return params;
}
function searchFundParam(params, idx, name, value, whereBy) {
  // params['filter[where][or][' + idx + '][' + name + '][like]'] = '%' + value + '%'
  params['filter[where][or][' + idx + '][' + name + '][regexp]'] = '/.*' + value + '.*/i';
  // params['filter[where][or][' + idx + '][' + name + '][regexp]'] = '.*'
  params['filter[where][or][' + idx + '][version]'] = _config2.default.environment.version;
  params = (0, _assign2.default)({}, params, whereParams('filter[where][or][' + idx + ']', whereBy));

  return params;
}
function baseReducer(state, action, actionTypes) {
  switch (action.type) {
    case actionTypes[0]:
      return (0, _extends3.default)({}, state, {
        loading: true,
        loaded: false,
        result: null,
        error: null
      });
    case actionTypes[1]:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        result: action.result,
        error: null
      });
    case actionTypes[2]:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        result: null,
        error: action.error
      });
    default:
      return state;
  }
}

function searchReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return baseReducer(state, action, [SEARCH, SEARCH_SUCCESS, SEARCH_FAIL]);
}
function shareClassReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return baseReducer(state, action, [SHARE_CLASS, SHARE_CLASS_SUCCESS, SHARE_CLASS_FAIL]);
}
function familyShareClassReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return baseReducer(state, action, [FAMILY_SHARE_CLASS, FAMILY_SHARE_CLASS_SUCCESS, FAMILY_SHARE_CLASS_FAIL]);
}

function familyShareClasses(fundFamily, page) {
  page = page || 1;
  return {
    types: [FAMILY_SHARE_CLASS, FAMILY_SHARE_CLASS_SUCCESS, FAMILY_SHARE_CLASS_FAIL],
    promise: function promise(client) {
      return client.get('/funds', {
        params: {
          // 'filter[fields][name]': 'true',
          // 'filter[fields][fund_id]': 'true',
          // 'filter[fields][investment_vehicle_id]': 'true',
          // 'filter[fields][fund_legal_name]': 'true',
          // 'filter[fields][ticker]': 'true',
          // 'filter[fields][version]': 'true',
          // 'filter[fields][currency]': 'true',
          // 'filter[fields][grade_deforestation]':'true',
          // 'filter[fields][po_producer_asset]':'true',
          // 'filter[fields][po_consumer_asset]':'true',
          // 'filter[fields][po_financier_asset]':'true',
          // 'filter[fields][po_all_asset]':'true',
          // 'filter[fields][po_producer_count]':'true',
          // 'filter[fields][po_consumer_count]':'true',
          // 'filter[fields][po_financier_count]':'true',
          // 'filter[fields][po_all_count]':'true',
          // 'filter[fields][po_producer_weight]':'true',
          // 'filter[fields][po_consumer_weight]':'true',
          // 'filter[fields][po_financier_weight]':'true',
          // 'filter[fields][po_all_weight]':'true',
          'filter[where][fund_family_name]': fundFamily,
          'filter[where][version]': _config2.default.environment.version,
          'filter[limit]': _config2.default.queryMaxFunds,
          'filter[skip]': (page - 1) * _config2.default.queryMaxFunds,

          'filter[order][0]': 'fund_net_assets DESC',
          'filter[include]': ['shareclass']
        }
      });
    }
  };
}

function shareClassDetails(fundId, investmentVehicleId) {
  return {
    types: [SHARE_CLASS, SHARE_CLASS_SUCCESS, SHARE_CLASS_FAIL],
    promise: function promise(client) {
      return _bluebird2.default.all([client.get('/shareclasses', {
        params: {
          'filter[where][investment_vehicle_id]': investmentVehicleId,
          'filter[where][version]': _config2.default.environment.version
        }
      }), client.get('/funds', {
        params: {
          'filter[include]': ['fundholdings', 'holdings'],
          'filter[where][fund_id]': fundId,
          'filter[where][version]': _config2.default.environment.version
        }
      })]).then(function (results) {
        var shareClassResult = results[0] && results[0][0] ? results[0][0] : null;
        var fundResult = results[1] && results[1][0] ? results[1][0] : null;
        return {
          shareClass: shareClassResult,
          fund: fundResult
        };
      });
    }
  };
}
function searchFunds(req, page, orderBy, whereBy, isDesc, noLimit) {
  var defaultSort = [{ order: 'grade_deforestation', isDesc: false }, { order: 'ussif', isDesc: true }, { order: 'po_producer_weight', isDesc: false }, { order: 'fund_share_class_net_assets', isDesc: true }];

  console.log('searchFunds:', { req: req, page: page, where: whereBy ? (0, _stringify2.default)(whereBy) : '', order: orderBy, desc: isDesc, noLimit: noLimit });
  page = page || 1;

  var params = {
    'filter[limit]': noLimit ? page * _config2.default.queryMaxFunds : _config2.default.queryMaxFunds,
    'filter[skip]': noLimit ? 0 : (page - 1) * _config2.default.queryMaxFunds
  };

  if (orderBy) {
    params = (0, _assign2.default)(params, {
      'filter[order][0]': orderBy + ' ' + (isDesc ? 'DESC' : 'ASC')
    });
    var idx = 1;
    // loop through default sorts
    defaultSort.forEach(function (sort) {
      if (sort.order !== orderBy) {
        // if its not orderBy add it
        params['filter[order][' + idx++ + ']'] = sort.order + ' ' + (sort.isDesc ? 'DESC' : 'ASC');
      }
    });
  } else {
    var _idx = 0;
    defaultSort.forEach(function (sort) {
      params['filter[order][' + _idx++ + ']'] = sort.order + ' ' + (sort.isDesc ? 'DESC' : 'ASC');
    });
    // params = Object.assign( params, {
    //   'filter[order][0]':'ussif DESC',
    //   'filter[order][1]':'fund_share_class_net_assets DESC'
    // })
  }

  if (req) {
    // const lowerReq = req.toLowerCase()
    // const upperReq = req.toUpperCase()
    var _idx2 = 0;
    params = searchFundParam(params, _idx2++, 'name', req, whereBy);
    // params = searchFundParam(params, idx++, 'name', lowerReq, whereBy )
    params = searchFundParam(params, _idx2++, 'fund_legal_name', req, whereBy);
    // params = searchFundParam(params, idx++, 'fund_legal_name', lowerReq, whereBy )
    params = searchFundParam(params, _idx2++, 'fund_family_name', req, whereBy);
    // params = searchFundParam(params, idx++, 'fund_family_name', lowerReq, whereBy )
    params = searchFundParam(params, _idx2++, 'ticker', req, whereBy);
  } else {
    params = (0, _assign2.default)({}, params, whereParams('filter[where]', whereBy));
    params = (0, _assign2.default)({}, params, {
      'filter[where][version]': _config2.default.environment.version
    });
  }

  // console.log('searchFunds params:',params )
  return {
    types: [SEARCH, SEARCH_SUCCESS, SEARCH_FAIL],
    promise: function promise(client) {
      return client.get('/shareclasses', {
        params: params
      }).then(function (result) {
        return { results: result, req: req, orderBy: orderBy };
      });
    }
  };
}

var TUTORIALDISMISS = 'tutorialdismiss';
var TUTORIALDISMISS_FAIL = 'tutorialdismiss/fail';
var TUTORIALDISMISS_SUCCESS = 'tutorialdismiss/success';

function tutorialdismissReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return baseReducer(state, action, [TUTORIALDISMISS, TUTORIALDISMISS_FAIL, TUTORIALDISMISS_SUCCESS]);
}

function tutorialdismissChange() {
  var tutorialdismiss = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  return {
    types: [TUTORIALDISMISS, TUTORIALDISMISS_FAIL, TUTORIALDISMISS_SUCCESS],
    promise: function promise(client) {
      return _bluebird2.default.all([new _bluebird2.default(function (resolve, reject) {
        resolve(tutorialdismiss);
      })]).then(function (results) {
        return results.length ? results[0] : false;
      });
    }
  };
}

var COMPANY = 'company';
var COMPANY_SUCCESS = 'company/success';
var COMPANY_FAIL = 'company/fail';

function companyReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return baseReducer(state, action, [COMPANY, COMPANY_SUCCESS, COMPANY_FAIL]);
}

function companies() {
  return {
    types: [COMPANY, COMPANY_SUCCESS, COMPANY_FAIL],
    promise: function promise(client) {
      return client.get('/companies', {
        params: {
          'filter[fields][company_id]': 'true',
          'filter[fields][short_name]': 'true',
          'filter[fields][primary_symbol]': 'true',
          'filter[fields][legal_name]': 'true',
          'filter[fields][is_po_producer]': 'true',
          'filter[fields][is_po_consumer]': 'true',
          'filter[fields][is_po_financier]': 'true',
          'filter[fields][version]': 'true',
          // 'filter[where][version]': config.environment.version,
          'filter[limit]': 1000,
          'filter[where][or][0][is_po_producer]': 1,
          'filter[where][or][0][version]': _config2.default.environment.version,
          'filter[where][or][1][is_po_consumer]': 1,
          'filter[where][or][1][version]': _config2.default.environment.version,
          'filter[where][or][2][is_po_financier]': 1,
          'filter[where][or][2][version]': _config2.default.environment.version
        }
      });
    }
  };
}

var COMPARE = 'compare';
var COMPARE_FAIL = 'compare/fail';
var COMPARE_SUCCESS = 'compare/success';

function compareReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return baseReducer(state, action, [COMPARE, COMPARE_SUCCESS, COMPARE_FAIL]);
}

// up to 4 shareclass ids will be provided
function compareShareclasses() {
  var s1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var s2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var s3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var s4 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var prefix = 'filter[where][or][';
  var shareclassIds = [s1, s2, s3, s4];
  var count = 0;
  var shareclassParams = {
    'filter[limit]': 4,
    'filter[include]': ['fund'],
    'filter[include][fund]': ['shareclass']
  };
  shareclassIds.forEach(function (id) {
    if (typeof id !== 'undefined' && id !== null && id !== 'N') {
      shareclassParams[prefix + count + '][investment_vehicle_id]'] = id;
      shareclassParams[prefix + count + '][version]'] = _config2.default.environment.version;
      count += 1;
    }
  });
  return {
    types: [COMPARE, COMPARE_SUCCESS, COMPARE_FAIL],
    promise: function promise(client) {
      return client.get('/shareclasses', {
        params: shareclassParams
      }).then(function (result) {
        return { results: result };
      });
    }
  };
}

var CART = 'cart';
var CART_FAIL = 'cart/fail';
var CART_SUCCESS = 'cart/success';

function cartReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return baseReducer(state, action, [CART, CART_SUCCESS, CART_FAIL]);
}

function cartChange() {
  var cart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var newShareclass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    types: [CART, CART_SUCCESS, CART_FAIL],
    promise: function promise(client) {
      return _bluebird2.default.all([new _bluebird2.default(function (resolve, reject) {
        var CART_MAX = 4;
        var EMPTY_SLOT_ID = 'N';
        var generateEmptySlot = function generateEmptySlot() {
          return { id: EMPTY_SLOT_ID, shareclassStub: {} };
        };
        var defaultCart = [];
        for (var i = 0; i < CART_MAX; i++) {
          defaultCart.push(generateEmptySlot());
        }
        if (cart.length !== CART_MAX) {
          cart = defaultCart;
        }
        var newId = newShareclass.investment_vehicle_id || EMPTY_SLOT_ID;
        // if we actually have a new shareclass to add
        if (newId !== EMPTY_SLOT_ID) {
          var cartIndexOfNewId = -1;
          var cartContainsNewId = false;
          var cartIndexOfOpenSlot = -1;
          var cartContainsOpenSlot = false;
          for (var _i = 0; _i < CART_MAX; _i++) {
            if (cart[_i].id === newId) {
              cartIndexOfNewId = _i;
              cartContainsNewId = true;
            } else if (cart[_i].id === EMPTY_SLOT_ID && cartIndexOfOpenSlot === -1) {
              cartIndexOfOpenSlot = _i;
              cartContainsOpenSlot = true;
            }
          }
          if (cartContainsNewId) {
            // if the cart has the id, it's a remove job.
            // assign 'N' to overwrite the shareclass id.
            cart[cartIndexOfNewId] = generateEmptySlot();
          } else {
            // if the cart does not have the id:
            if (cartContainsOpenSlot) {
              // if there's an open slot, we'll add the id and overwrite the N.
              cart[cartIndexOfOpenSlot] = {
                id: newId,
                shareclassStub: {
                  name: newShareclass.name,
                  ticker: newShareclass.ticker,
                  fund_id: newShareclass.fund_id,
                  investment_vehicle_id: newShareclass.investment_vehicle_id,
                  fund_legal_name: newShareclass.fund_legal_name,
                  fund_family_name: newShareclass.fund_family_name
                }
              };
            }
            // if there's no open slots, we'll do nothing.
          }
        }

        resolve(cart);
      })]).then(function (results) {
        var resultsArr = results[0] ? results[0] : null;
        return { results: resultsArr };
      });
    }
  };
}

var FUNDS_BY_STRATEGY = 'funds_by_strategy';
var FUNDS_BY_STRATEGY_SUCCESS = 'funds_by_strategy/success';
var FUNDS_BY_STRATEGY_FAIL = 'funds_by_strategy/fail';

function fundsByStrategyReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return baseReducer(state, action, [FUNDS_BY_STRATEGY, FUNDS_BY_STRATEGY_SUCCESS, FUNDS_BY_STRATEGY_FAIL]);
}

function getFundsByStrategy(strategyNames) {
  var gradeField = {
    'Fossil Free Funds': 'grade_fossil',
    'Deforestation Free Funds': 'grade_deforestation',
    'Gender Equality Funds': 'grade_gender_equality',
    'Gun Free Funds': 'grade_guns',
    'Prison Free Funds': 'grade_prison_industrial_complex',
    'Weapon Free Funds': 'grade_military',
    'Tobacco Free Funds': 'grade_tobacco'
  }[_config2.default.app.title] || null;

  var params = {
    'filter[fields][fund_legal_name]': 'true',
    'filter[fields][fund_id]': 'true',
    'filter[fields][investment_vehicle_id]': 'true',
    'filter[fields][ticker]': 'true',
    'filter[fields][strategy_name]': 'true',
    'filter[fields][version]': 'true',
    'filter[order]': 'fund_legal_name ASC'
  };
  if (gradeField) {
    params['filter[fields][' + gradeField + ']'] = 'true';
  }
  for (var i = 0; i < strategyNames.length; i++) {
    if (strategyNames[i]) {
      params['filter[where][or][' + i + '][strategy_name]'] = strategyNames[i];
      params['filter[where][or][' + i + '][version]'] = _config2.default.environment.version;
    }
  }
  return {
    types: [FUNDS_BY_STRATEGY, FUNDS_BY_STRATEGY_SUCCESS, FUNDS_BY_STRATEGY_FAIL],
    promise: function promise(client) {
      return client.get('/funds', { params: params });
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/search.js
// module id = 66
// module chunks = 0